import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { QuoteForm } from '../components/QuoteForm';
import { Link } from 'react-router-dom';
export function ContactPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const areas = [{
    county: 'St. Clair County',
    cities: ['Port Huron', 'Marysville', 'St. Clair', 'Marine City', 'New Baltimore', 'Algonac', 'Ira Township', 'China Township', 'Casco Township']
  }, {
    county: 'Macomb County',
    cities: ['Harrison Township', 'Clinton Township', 'Chesterfield', 'Macomb Township', 'Sterling Heights', 'Warren', 'Roseville', 'Utica', 'St. Clair Shores']
  }, {
    county: 'Oakland County',
    cities: ['Troy', 'Rochester Hills', 'Auburn Hills', 'Pontiac', 'Clarkston', 'Lake Orion', 'Oxford']
  }];
  return <div className="w-full bg-white" data-id="element-693">
      {/* Hero */}
      <section className="relative min-h-[35vh] flex items-center pt-20 pb-12 overflow-hidden bg-brand-gray-dark" data-id="element-694">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full relative z-10" data-id="element-695">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-696">
            <h1 className="font-heading font-black text-4xl md:text-5xl text-white mb-4" data-id="element-697">
              Contact{' '}
              <span className="text-brand-blue" data-id="element-698">
                Moceri Residential Services
              </span>
            </h1>
            <p className="font-body text-xl text-gray-300 max-w-2xl" data-id="element-699">
              Ready to start your project? Reach out today for a free,
              no-obligation estimate.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Info + Form */}
      <section className="py-20" data-id="element-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-701">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-20" data-id="element-702">
            {/* Info */}
            <div className="w-full lg:w-5/12" data-id="element-703">
              <h2 className="font-heading font-bold text-3xl text-brand-gray-dark mb-8" data-id="element-704">
                Get In Touch
              </h2>
              <div className="space-y-8 mb-12" data-id="element-705">
                <div className="flex items-start gap-4" data-id="element-706">
                  <div className="w-12 h-12 rounded-full bg-brand-blue/10 flex items-center justify-center shrink-0" data-id="element-707">
                    <Phone className="text-brand-blue" size={24} data-id="element-708" />
                  </div>
                  <div data-id="element-709">
                    <h3 className="font-heading font-bold text-lg text-brand-gray-dark mb-1" data-id="element-710">
                      Phone
                    </h3>
                    <a href="tel:5862033701" className="font-body text-xl text-brand-blue hover:text-brand-blue-dark transition-colors font-semibold" data-id="element-711">
                      (586) 203-3701
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-712">
                  <div className="w-12 h-12 rounded-full bg-brand-blue/10 flex items-center justify-center shrink-0" data-id="element-713">
                    <Mail className="text-brand-blue" size={24} data-id="element-714" />
                  </div>
                  <div data-id="element-715">
                    <h3 className="font-heading font-bold text-lg text-brand-gray-dark mb-1" data-id="element-716">
                      Email
                    </h3>
                    <a href="mailto:MoceriRS@gmail.com" className="font-body text-lg text-brand-gray hover:text-brand-blue transition-colors" data-id="element-717">
                      MoceriRS@gmail.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-718">
                  <div className="w-12 h-12 rounded-full bg-brand-blue/10 flex items-center justify-center shrink-0" data-id="element-719">
                    <MapPin className="text-brand-blue" size={24} data-id="element-720" />
                  </div>
                  <div data-id="element-721">
                    <h3 className="font-heading font-bold text-lg text-brand-gray-dark mb-1" data-id="element-722">
                      Location
                    </h3>
                    <p className="font-body text-brand-gray" data-id="element-723">
                      Harrison Township, Michigan
                    </p>
                    <p className="font-body text-sm text-brand-gray" data-id="element-724">
                      Serving St. Clair, Macomb & Oakland Counties
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-725">
                  <div className="w-12 h-12 rounded-full bg-brand-blue/10 flex items-center justify-center shrink-0" data-id="element-726">
                    <Clock className="text-brand-blue" size={24} data-id="element-727" />
                  </div>
                  <div data-id="element-728">
                    <h3 className="font-heading font-bold text-lg text-brand-gray-dark mb-1" data-id="element-729">
                      Business Hours
                    </h3>
                    <p className="font-body text-brand-gray" data-id="element-730">
                      Monday – Saturday: 7:00 AM – 7:00 PM
                    </p>
                    <p className="font-body text-brand-gray" data-id="element-731">Sunday: Closed</p>
                  </div>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="bg-gray-100 rounded-xl border border-gray-200 p-8 flex flex-col items-center justify-center min-h-[200px]" data-id="element-732">
                <MapPin size={40} className="text-brand-blue mb-3" data-id="element-733" />
                <p className="font-heading font-bold text-brand-gray-dark text-center" data-id="element-734">
                  Harrison Township, MI
                </p>
                <p className="font-body text-sm text-brand-gray text-center" data-id="element-735">
                  Serving Southeast Michigan
                </p>
              </div>
            </div>

            {/* Form */}
            <div className="w-full lg:w-7/12" data-id="element-736">
              <QuoteForm data-id="element-737" />
            </div>
          </div>
        </div>
      </section>

      {/* Service Areas */}
      <section className="py-16 bg-gray-50 border-t border-gray-200" data-id="element-738">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-739">
          <h2 className="font-heading font-bold text-2xl text-brand-gray-dark mb-8 text-center" data-id="element-740">
            Our Service Areas
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-741">
            {areas.map((area, index) => <div key={index} className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm" data-id="element-742">
                <h3 className="font-heading font-bold text-lg text-brand-blue mb-4 border-b border-gray-100 pb-3" data-id="element-743">
                  {area.county}
                </h3>
                <ul className="space-y-2" data-id="element-744">
                  {area.cities.map((city, i) => <li key={i} data-id="element-745">
                      <Link to={`/area/${city.toLowerCase().replace(/\s+/g, '-')}`} className="font-body text-sm text-brand-gray hover:text-brand-blue transition-colors" data-id="element-746">
                        {city}
                      </Link>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}